import { useMutation } from '@tanstack/react-query';
import { FeatureFlagsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeatureFlagsControllerRestoreFeatureFlagMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['featureFlagsControllerRestoreFeatureFlag', accessControlScope],
        mutationFn: async (args) => {
            const api = new FeatureFlagsApi(accessControlConfig);
            return api.featureFlagsControllerRestoreFeatureFlag(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeatureFlagsControllerRestoreFeatureFlagMutation.js.map